export const createProductTemplatesActions = (state) => {
    const normalizeArray = (items) => (Array.isArray(items) ? [...items] : [])

    // --- Product Templates ---
    const setProductTemplates = (items) => {
        state.productTemplates.value = normalizeArray(items)
    }

    const setProductTemplatesLoading = (value) => {
        state.productTemplatesLoading.value = Boolean(value)
    }

    const setProductTemplatesFilters = (filters = {}) => {
        state.productTemplatesFilters.value = {
            ...state.productTemplatesFilters.value,
            ...filters
        }
    }

    const resetProductTemplatesFilters = () => {
        state.productTemplatesFilters.value = state.createProductTemplatesFilters()
    }

    const setProductionFileInPaths = (items) => {
        state.productionFileInPaths.value = normalizeArray(items)
    }

    const setFoldingTypes = (items) => {
        state.foldingTypes.value = normalizeArray(items)
    }

    return {
        // Setters
        setProductTemplates,
        setProductTemplatesLoading,
        setProductTemplatesFilters,
        resetProductTemplatesFilters,
        setProductionFileInPaths,
        setFoldingTypes
    }
}
